import { render, staticRenderFns } from "./ApeironCommissionSplitAndSummary.vue?vue&type=template&id=464eff32"
import script from "./ApeironCommissionSplitAndSummary.vue?vue&type=script&lang=js"
export * from "./ApeironCommissionSplitAndSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports